<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 469.333 469.333" style="enable-background:new 0 0 469.333 469.333;" xml:space="preserve">
<g>
	<g>
		<path d="M467.065,366.76c-0.313-0.396-30.938-39.802-40.896-71.302c-2.354-7.5-5.313-18.063-8.708-30.167
			c-16.188-57.906-30.917-107.177-47.25-123.5c-17.698-17.698-86.105-29.508-114.208-33.711V42.667
			C256.002,19.135,236.857,0,213.336,0h-42.667c-5.896,0-10.667,4.771-10.667,10.667c0,17.646-14.354,32-32,32s-32-14.354-32-32
			C96.002,4.771,91.232,0,85.336,0H42.669C19.148,0,0.002,19.135,0.002,42.667v298.667C0.002,364.865,19.148,384,42.669,384h42.667
			c5.896,0,10.667-4.771,10.667-10.667c0-17.646,14.354-32,32-32s32,14.354,32,32c0,5.896,4.771,10.667,10.667,10.667h42.667
			c4.607,0,9.057-1.025,13.413-2.527c9.292,8.62,19.811,15.178,30.837,21.861c21.729,13.188,44.229,26.823,63.854,60.688
			c1.917,3.292,5.417,5.313,9.229,5.313c101.5,0,137.604-91.26,137.958-92.188C469.961,373.656,469.377,369.708,467.065,366.76z
			 M256.002,197.083l33.813,13.531c1.646,5.792,4.458,15.167,7.271,22.479c-1.292,2.281-2.417,4.823-3.604,7.531
			c-1.938,4.417-4.042,9.25-7,13c-10.681-7.612-21.523-23.746-30.479-40.895V197.083z M180.273,362.667
			C175.315,338.354,153.752,320,128.002,320s-47.313,18.354-52.271,42.667H42.669c-11.771,0-21.333-9.573-21.333-21.333V42.667
			c0-11.76,9.563-21.333,21.333-21.333h33.062C80.69,45.646,102.252,64,128.002,64s47.313-18.354,52.271-42.667h33.063
			c11.771,0,21.333,9.573,21.333,21.333v127.892c-13.319-19.533-35.76-42.628-56.104-46.767
			c-10.188-2.104-19.229,0.448-26.104,7.333c-25.688,25.667-10.979,69.333,9.417,98.927c16.333,23.698,28.458,51.677,30.167,69.625
			c0.292,2.979,0.417,5.802,0.542,8.594c0.655,14.245,1.563,29.083,18.522,54.396H180.273z M336.627,447.875
			c-21.708-34.719-47.25-50.208-67.979-62.781c-14.542-8.813-27.083-16.427-36.021-28.698
			c-17.583-24.167-18.083-35.167-18.729-49.104c-0.146-3.135-0.292-6.302-0.604-9.635c-2.063-21.583-15.333-52.875-33.833-79.708
			c-16.458-23.854-27.188-56.479-11.917-71.74c1.25-1.24,2.896-2.25,6.771-1.521c16.708,3.406,43.667,34.49,50.458,51.302
			c8.167,20.229,30.271,68.542,59.146,80.531c3.292,1.333,7.063,0.979,10-0.979c10.667-7.104,15.542-18.229,19.104-26.344
			c1.021-2.333,2.438-5.531,2.396-5.76c4.354-3.021,5.833-8.792,3.458-13.542c-3.25-6.49-8.25-23.865-9.917-30.01
			c-0.875-3.24-3.208-5.875-6.333-7.125l-46.625-18.65v-44.411c38.773,6,89.074,17.135,99.125,27.176
			c13.708,13.708,31.292,76.583,41.792,114.156c3.458,12.375,6.5,23.177,8.917,30.844c8.938,28.333,31.375,60.458,40.5,72.833
			C437.94,391.75,406.169,444.979,336.627,447.875z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
